import styled from 'styled-components'

export const StyledLogout = styled.div``
